import { Component, ElementRef, HostListener, ViewChild } from "@angular/core";
import { Location } from "@angular/common";
import { EventService } from "src/app/services/event.service";
import { languages } from "src/app/shared/constants/app-enums";
import { selectedLang } from "src/app/app.component";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent {
  isRotated: boolean = false;
  currentYear = new Date().getFullYear();
  // showWidget(section: string): void {
  //   this.eventService.showBuyWidget(section);
  // }
  @ViewChild("navigation") navigation!: ElementRef;

  lang: any = localStorage.getItem("currentlang");
  languagesList: Array<any> = languages;
  currentLanguage: any;
  selectedLanguage: any;
  hashKey: string = "";

  about = [
    {
      navName: "footer_nav_1",
      routeName: "",
      link: "https://www.wsmcasino.com/terms",
    },
    {
      navName: "footer_nav_2",
      routeName: "",
      link: "https://www.wsmcasino.com/responsible-gambling",
    },
    {
      navName: "footer_nav_3",
      routeName: "",
      link: "https://www.wsmcasino.com/privacy-policy",
    },
    {
      navName: "footer_nav_4",
      routeName: "",
      link: "https://www.wsmcasino.com/aml-policy",
    },
    {
      navName: "footer_nav_5",
      routeName: "",
      link: "https://www.wsmcasino.com/faq",
    },
    {
      navName: "footer_nav_11",
      routeName: "",
      link: "https://wallstreetmemes.medium.com/",
    },
  ];

  casino = [
    {
      navName: "footer_nav_6",
      routeName: "",
      link: "https://www.wsmcasino.com/casino",
    },
    {
      navName: "footer_nav_7",
      routeName: "",
      link: "https://www.wsmcasino.com/promotions",
    },
    {
      navName: "footer_nav_8",
      routeName: "",
      link: "https://www.wsmcasino.com/bonus-terms",
    },
  ];

  sport = [
    {
      navName: "footer_nav_9",
      routeName: "",
      link: "https://www.wsmcasino.com/sports",
    },
    {
      navName: "footer_nav_10",
      routeName: "",
      link: "https://www.wsmcasino.com/terms_and_conditions_sports",
    },
  ];
  constructor(
    private location: Location,
    private translate: TranslateService,
    private eventService: EventService
  ) {
    this.eventService.getLang().subscribe((val: any) => {
      this.currentLanguage = val || "en";
      this.selectedLanguage = this.languagesList.filter(
        (x) => x.value === this.currentLanguage
      )[0];
    });
  }

  // navigateToSection(section: string, isHome = false): void {

  //   this.eventService.scrollToFn(section);
  //  /* if(isHome) {
  //     window.location.href = 'https://web3.wsmcasino.com';
  //   }else if (!this.walletAddress){
  //     this.eventService.showBuyWidget(section);
  //   }else{
  //     this.eventService.scrollToFn(section);
  //   }*/
  // }
  ngOnInit(): void {
    if (!this.currentLanguage) {
      this.currentLanguage = selectedLang;
      this.selectedLanguage = this.languagesList.filter(
        (x) => x.value === this.currentLanguage
      )[0];
    }
  }

  changeLanguage(requestLang: any): void {
    this.currentLanguage = requestLang;
    this.translate.use(this.currentLanguage);
    this.eventService.setLang(this.currentLanguage);
    this.selectedLanguage = this.languagesList.filter(
      (x) => x.value === this.currentLanguage
    )[0];
    this.replaceURL();
  }
  replaceURL(): void {
    const current_url = this.location.path().split("/");
    current_url.shift();
    current_url.splice(0, 1, this.currentLanguage);
    const new_url = current_url.join("/");
    this.hashKey = window.location.hash || "";
    this.location.replaceState("/" + new_url + this.hashKey);
  }
}
